import { render, staticRenderFns } from "./TopContentTermsOfService.vue?vue&type=template&id=55cabfc3&"
import script from "./TopContentTermsOfService.vue?vue&type=script&lang=ts&"
export * from "./TopContentTermsOfService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports